var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pre',{directives:[{name:"dompurify-html",rawName:"v-dompurify-html",value:(_vm.highlightedFormulaHtml),expression:"highlightedFormulaHtml"}],class:{'is-text': _vm.text},attrs:{"id":"formula-block"}})
}
var staticRenderFns = []

export { render, staticRenderFns }